"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalEvents = exports.DashboardEvents = exports.ControlCenterEvents = exports.DemandPartnerEventsHelper = exports.AdUnitEventsHelper = exports.EventAction = exports.EventSubFeature = exports.EventFeature = exports.Events = exports.Event = void 0;
const core_1 = require("@angular/core");
const token_service_1 = require("./token.service");
const app_module_1 = require("./app.module");
let Event = class Event {
    constructor(params) {
        this.eventURL = '/event';
        Object.assign(this, params);
        this._http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
    }
    create() {
        return this._http.post(this.eventURL, this.toJson()).toPromise();
    }
    equals(event) {
        return event.bidder === this.bidder
            && event.subject === this.subject
            && event.subjectID === this.subjectID
            && event.feature === this.feature
            && event.subFeature === this.subFeature
            && event.context === this.context
            && event.action === this.action
            && event.user === this.user
            && event.index === this.index
            && event.initialPosition === this.initialPosition
            && event.finalPosition === this.finalPosition;
    }
    props() {
        return {
            subject: this.subject,
            subjectID: this.subjectID,
            feature: this.feature,
            subFeature: this.subFeature,
            context: this.context,
            action: this.action,
            user: this.user,
            index: this.index,
            initialPosition: this.initialPosition,
            finalPosition: this.finalPosition,
            bidder: this.bidder
        };
    }
    toJson() {
        return JSON.stringify(this.props());
    }
    isValid() {
        return this.subject;
    }
};
exports.Event = Event;
exports.Event = Event = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [Object])
], Event);
let Events = class Events {
    constructor() {
        this.eventBatchURL = '/event/batch';
        this.index = 0;
        this.all = [];
        this._http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
    }
    add(event) {
        event.index = this.index++;
        this.all.push(event);
    }
    clear() {
        this.index = 0;
        this.all = [];
    }
    batchCreate() {
        if (this.all.length > 0) {
            return this._http.post(this.eventBatchURL, this.toJson()).toPromise();
        }
    }
    toJson() {
        return JSON.stringify(this.all.map(e => e.props()));
    }
    getUser() {
        return this.user;
    }
    getBidder() {
        return this.bidder;
    }
};
exports.Events = Events;
exports.Events = Events = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [])
], Events);
let EventFeature = class EventFeature {
};
exports.EventFeature = EventFeature;
EventFeature.controlCenter = "control-center";
EventFeature.dashboard = "dashboard";
EventFeature.portal = "portal";
exports.EventFeature = EventFeature = __decorate([
    (0, core_1.Injectable)()
], EventFeature);
let EventSubFeature = class EventSubFeature {
};
exports.EventSubFeature = EventSubFeature;
// Control Center
EventSubFeature.demandPartner = "demand-partner";
EventSubFeature.adUnit = "ad-unit";
EventSubFeature.priceBucket = "price-bucket";
EventSubFeature.advancedOption = "advanced-option";
EventSubFeature.bidder = "bidder";
EventSubFeature.help = "help";
EventSubFeature.adInspector = "ad-inspector";
// Dashboard
EventSubFeature.filter = 'filter';
EventSubFeature.export = 'export';
EventSubFeature.report = 'report';
exports.EventSubFeature = EventSubFeature = __decorate([
    (0, core_1.Injectable)()
], EventSubFeature);
let EventAction = class EventAction {
};
exports.EventAction = EventAction;
EventAction.enabled = "enabled";
EventAction.disabled = "disabled";
EventAction.added = "added";
EventAction.deleted = "deleted";
EventAction.moved = "moved";
EventAction.reset = "reset";
EventAction.changed = "changed";
EventAction.paginate = "paginate";
EventAction.clicked = "clicked";
EventAction.collapsed = "collapsed";
EventAction.expanded = "expanded";
EventAction.toggled = "toggled";
EventAction.selected = "selected";
EventAction.unselected = "unselected";
EventAction.export = "export";
exports.EventAction = EventAction = __decorate([
    (0, core_1.Injectable)()
], EventAction);
let AdUnitEventsHelper = class AdUnitEventsHelper {
    moved(oldAdUnits, newAdUnits) {
        let events = [];
        for (let i = 0; i < newAdUnits.length; i++) {
            let fromAdUnit = oldAdUnits[i];
            let toAdUnit = newAdUnits[i];
            if (!fromAdUnit.equals(toAdUnit)) {
                let event = this.buildMoveEvent(i, newAdUnits, oldAdUnits);
                if (event.isValid())
                    events.push(event);
            }
        }
        return events;
    }
    buildMoveEvent(position, newAdUnits, oldAdUnits) {
        let fromAdUnit = oldAdUnits[position];
        let initialPosition = position;
        let finalPosition = newAdUnits.findIndex(adUnit => adUnit.equals(fromAdUnit));
        return new Event({
            subFeature: EventSubFeature.adUnit,
            subject: fromAdUnit.displayName,
            subjectID: fromAdUnit.id,
            initialPosition: initialPosition,
            finalPosition: finalPosition,
            action: EventAction.moved
        });
    }
};
exports.AdUnitEventsHelper = AdUnitEventsHelper;
exports.AdUnitEventsHelper = AdUnitEventsHelper = __decorate([
    (0, core_1.Injectable)()
], AdUnitEventsHelper);
let DemandPartnerEventsHelper = class DemandPartnerEventsHelper {
    moved(oldDemandPartners, newDemandPartners) {
        let events = [];
        for (let i = 0; i < newDemandPartners.length; i++) {
            let fromDemandPartner = oldDemandPartners[i];
            let toDemandPartner = newDemandPartners[i];
            if (fromDemandPartner.adUnitPartnerId !== toDemandPartner.adUnitPartnerId) {
                let event = this.buildMoveEvent(i, newDemandPartners, oldDemandPartners);
                if (event.isValid())
                    events.push(event);
            }
        }
        return events;
    }
    buildMoveEvent(position, newDemandPartners, oldDemandPartners) {
        let fromDemandPartner = oldDemandPartners[position];
        let initialPosition = position;
        let finalPosition = newDemandPartners.findIndex(demandPartner => demandPartner.adUnitPartnerId === fromDemandPartner.adUnitPartnerId);
        return new Event({
            subFeature: EventSubFeature.demandPartner,
            subject: fromDemandPartner.code,
            subjectID: fromDemandPartner.id,
            initialPosition: initialPosition,
            finalPosition: finalPosition,
            action: EventAction.moved
        });
    }
};
exports.DemandPartnerEventsHelper = DemandPartnerEventsHelper;
exports.DemandPartnerEventsHelper = DemandPartnerEventsHelper = __decorate([
    (0, core_1.Injectable)()
], DemandPartnerEventsHelper);
let ControlCenterEvents = class ControlCenterEvents extends Events {
    constructor(params) {
        super();
        Object.assign(this, params);
        this.adUnitHelper = new AdUnitEventsHelper();
        this.demandPartnerHelper = new DemandPartnerEventsHelper();
    }
    batchAdd(events) {
        for (let event of events) {
            this.add(event);
        }
    }
    add(event) {
        Object.assign(event, this.baseEvent());
        super.add(new Event(event));
    }
    baseEvent() {
        return {
            feature: EventFeature.controlCenter,
            user: this.user,
            bidder: this.bidder
        };
    }
};
exports.ControlCenterEvents = ControlCenterEvents;
exports.ControlCenterEvents = ControlCenterEvents = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [Object])
], ControlCenterEvents);
class DashboardEvents extends Events {
    constructor(params) {
        super();
        Object.assign(this, params);
    }
    add(event) {
        Object.assign(event, this.baseEvent());
        super.add(new Event(event));
    }
    baseEvent() {
        return {
            feature: EventFeature.dashboard,
            user: this.getUser(),
            bidder: this.getBidder()
        };
    }
    send(event) {
        Object.assign(event, this.baseEvent());
        new Event(event).create();
    }
}
exports.DashboardEvents = DashboardEvents;
class PortalEvents extends Events {
    constructor(params) {
        super();
        Object.assign(this, params);
    }
    add(event) {
        Object.assign(event, this.baseEvent());
        super.add(new Event(event));
    }
    send(event) {
        Object.assign(event, this.baseEvent());
        new Event(event).create();
    }
    baseEvent() {
        return {
            feature: EventFeature.portal,
            user: this.getUser(),
            bidder: this.getBidder()
        };
    }
}
exports.PortalEvents = PortalEvents;
//# sourceMappingURL=events.js.map